class Scale
{
    static get TYPE_UNRESIZED()
    {
        return 0
    }

    static get TYPE_COVER()
    {
        return 1
    }

    static get TYPE_CONTAIN()
    {
        return 2
    }

    static getBounds(containerW, containerH, contentW, contentH, type = Scale.TYPE_COVER)
    {
        const s = new Scale(contentW, contentH)
        s.type = type
        
        return s.getBounds(containerW, containerH)
    }

    constructor(w, h)
    {
        this._initW = w
        this._initH = h
        this._w = w
        this._h = h
        this._s = 1
        this.type = Scale.TYPE_COVER
    }

    setH(val)
    {
        this._h = val
        this._w = val * this._initW / this._initH
        this._s = val / this._initH
    }

    setW(val)
    {
        this._w = val
        this._h = val * this._initH / this._initW
        this._s = val / this._initW
    }

    getH()
    {
        return this._h
    }

    getW()
    {
        return this._w
    }

    getSize()
    {
        return {x: this._w, h: this._h}
    }

    getBounds(containerW, containerH)
    {
        if (this.type === Scale.TYPE_COVER)
        {
            if (this._w / this._h > containerW / containerH)
            {
                this.setH(containerH)
            }
            else
            {
                this.setW(containerW)
            }
        }
        else if (this.type === Scale.TYPE_CONTAIN)
        {
            if (this._w / this._h > containerW / containerH)
            {
                this.setW(containerW)
            }
            else
            {
                this.setH(containerH)
            }
        }
        const s = this._s
        return {
            s,
            w: this._w,
            h: this._h,
            x: (containerW - this._w) * 0.5,
            y: (containerH - this._h) * 0.5
        }
    }
}

export default Scale


// WEBPACK FOOTER //
// ./src/scripts/components/app-hexagon/Scale.js